import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISTDBoxes_Form_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISTDBoxes_Form_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  GetUserWithGroupDetails: any[];
  GetUserWithGroupDetails_dummy: any[];
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  SelectSTDBoxes: any[];
  SelectSTDBoxes_dummy: any[];
  SelectStdproductsForProductid: any[];
  SelectStdproductsForProductid_dummy: any[];
  GetStationInfo: any[];
  GetStationInfo_dummy: any[];
  GetProductDetail: any[];
  GetProductDetail_dummy: any[];
  GetLabelWithBoxId: any[];
  GetLabelWithBoxId_dummy: any[];
  SameProductCurrentCount: any[];
  SameProductCurrentCount_dummy: any[];
  GenerateExactLabel: string;
  GenerateExactLabel_dummy: string;
  STDEtiketSave: number;
  STDEtiketSave_dummy: number;
  ToggleVisibilityOf: string;
  ToggleVisibilityOf_dummy: string;
  DownloadFile: any;
  DownloadFile_dummy: any;
  STDCustomerProductsWithProductCode: any[];
  STDCustomerProductsWithProductCode_dummy: any[];
  ChangeEnabledOf: any;
  ChangeEnabledOf_dummy: any;
  STDCustomerProductsSave: number;
  STDCustomerProductsSave_dummy: number;
  GetSameProductCount: any[];
  GetSameProductCount_dummy: any[];
  DeleteEtiketForAddedManuelBox: number;
  DeleteEtiketForAddedManuelBox_dummy: number;
  UpdateBoxCount: number;
  UpdateBoxCount_dummy: number;
  STDEtiketDeleteByBoxId: number;
  STDEtiketDeleteByBoxId_dummy: number;
  STDBoxesSave: number;
  STDBoxesSave_dummy: number;
  StringForLabelName: string;
  StringForLabelName_dummy: string;
  Notify: boolean;
  Notify_dummy: boolean;
  GetNewBoxIdent: any[];
  GetNewBoxIdent_dummy: any[];
  Subtract: number;
  Subtract_dummy: number;
  STDOrdersUpdateDeletingBox: number;
  STDOrdersUpdateDeletingBox_dummy: number;
  DeleteEtiketForDeletingBox: number;
  DeleteEtiketForDeletingBox_dummy: number;
  UpdateBoxCountAfterDeleteBox: number;
  UpdateBoxCountAfterDeleteBox_dummy: number;
  STDBoxesDeleteById: number;
  STDBoxesDeleteById_dummy: number;
  isComp324177Visible: "visible" | "hidden";
  isComp423219Visible: "visible" | "hidden";
  isComp448809Visible: "visible" | "hidden";
  isComp891256Visible: "visible" | "hidden";
  isComp804937Enabled: "enabled" | "disabled";
  isComp865868Enabled: "enabled" | "disabled";
  isComp238713Enabled: "enabled" | "disabled";
  isComp34223Enabled: "enabled" | "disabled";
}

export class STDBoxes_Form_ScreenBase extends React.PureComponent<
  ISTDBoxes_Form_ScreenProps,
  any
> {
  stdboxes_form_880268_value_kuikaAutoCompleteRef: React.RefObject<any>;
  stdboxes_form_34223_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "25c1b361-4262-e567-aef0-4b8ceff8261c",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "ea2af393-7864-0865-c06a-2b07d10d3ec8",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "576bb204-d162-4198-a38c-d8061f12042a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 428726, PropertyName: "value", Value: "KLT - Kutu  Form" },
        { Id: 280093, PropertyName: "value", Value: "Kutu ID" },
        { Id: 238713, PropertyName: "placeholder", Value: "15" },
        { Id: 68956, PropertyName: "value", Value: "Kutu Etiket" },
        { Id: 923292, PropertyName: "value", Value: "Kutu Etiket" },
        { Id: 199963, PropertyName: "value", Value: "İstasyon" },
        {
          Id: 536829,
          PropertyName: "value",
          Value: "Toplam Kutu Sayısı - Aynı Ürün",
        },
        { Id: 606034, PropertyName: "value", Value: "Malzeme " },
        { Id: 880268, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 972129, PropertyName: "value", Value: "Müşteri Malzeme Kodu" },
        { Id: 865868, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 517781, PropertyName: "value", Value: "Müşteri Malzeme Tanımı" },
        { Id: 804937, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 156988, PropertyName: "value", Value: "Kutu Tipi" },
        { Id: 34223, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 628129, PropertyName: "value", Value: "İçerik Adet" },
        { Id: 994812, PropertyName: "placeholder", Value: "15" },
        { Id: 448809, PropertyName: "label", Value: "Kaydet" },
        { Id: 891256, PropertyName: "value", Value: "Kutuyu sil" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.stdboxes_form_880268_value_kuikaAutoCompleteRef = React.createRef();
    this.stdboxes_form_865868_value_kuikaTextInputRef = React.createRef();
    this.stdboxes_form_804937_value_kuikaTextInputRef = React.createRef();
    this.stdboxes_form_34223_value_kuikaSelectBoxRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      GetUserWithGroupDetails: [],
      IfThenElse: false,
      SelectSTDBoxes: [],
      SelectStdproductsForProductid: [],
      GetStationInfo: [],
      GetProductDetail: [],
      GetLabelWithBoxId: [],
      SameProductCurrentCount: [],
      GenerateExactLabel: "",
      STDEtiketSave: 0,
      ToggleVisibilityOf: "",
      DownloadFile: "",
      STDCustomerProductsWithProductCode: [],
      dataSource_34223: [
        { key: "3215", text: "3215" },
        { key: "4315", text: "4315" },
        { key: "Kanban Ek", text: "Kanban Ek" },
      ],
      isComp324177Visible: "hidden",
      isComp423219Visible: "hidden",
      isComp448809Visible: "hidden",
      isComp891256Visible: "hidden",
      isComp804937Enabled: "disabled",
      isComp865868Enabled: "disabled",
      isComp238713Enabled: "disabled",
      isComp34223Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("stdboxes_form", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    if (true) {
      await this.STDBoxes_FormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("stdboxes_form", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("stdboxes_form", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.STDBoxes_FormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      stdboxes_form_238713_value:
        this.state.SelectSTDBoxes?.at?.(0)?.boxIdentifier ?? undefined,
      stdboxes_form_880268_value:
        this.state.SelectSTDBoxes?.at?.(0)?.productId ?? undefined,
      stdboxes_form_865868_value:
        this.state.SelectSTDBoxes?.at?.(0)?.customerProductCode ?? undefined,
      stdboxes_form_804937_value:
        this.state.SelectSTDBoxes?.at?.(0)?.customerProductDesc ?? undefined,
      stdboxes_form_34223_value:
        this.state.SelectSTDBoxes?.at?.(0)?.boxType ?? undefined,
      stdboxes_form_994812_value:
        this.state.SelectSTDBoxes?.at?.(0)?.expectedQuantity ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  STDBoxes_FormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetUserWithGroupDetails = result?.data.getUserWithGroupDetails;
    stateVars.isComp448809Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxEdit
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp891256Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxDelete
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxDelete
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_FormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "STDBoxes_Form",
      "NavigateScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDBoxes_FormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxEdit
            : null
        ),
        true
      ) ||
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxCreate
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxCreate
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDBoxes_FormPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_FormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      StationId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].productId
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].productId
            : null
        ),
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.SelectSTDBoxes = result?.data.selectSTDBoxes;
    formVars.stdboxes_form_238713_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxIdentifier
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxIdentifier
        : null
    );
    formVars.stdboxes_form_801715_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxCount
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxCount
        : null
    );
    formVars.stdboxes_form_880268_value =
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null;
    formVars.stdboxes_form_880268_options =
      stateVars.SelectStdproductsForProductid;
    formVars.stdboxes_form_865868_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].customerProductCode
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].customerProductCode
        : null
    );
    formVars.stdboxes_form_804937_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].customerProductDesc
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].customerProductDesc
        : null
    );
    formVars.stdboxes_form_34223_value =
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxType
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxType
        : null;
    formVars.stdboxes_form_994812_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].expectedQuantity
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].expectedQuantity
        : null
    );
    stateVars.isComp238713Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].id
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.SelectStdproductsForProductid =
      result?.data.selectStdproductsForProductid;

    formVars.stdboxes_form_880268_value =
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null;
    formVars.stdboxes_form_880268_options =
      stateVars.SelectStdproductsForProductid;
    stateVars.GetStationInfo = result?.data.getStationInfo;
    formVars.stdboxes_form_118875_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationInfo !== undefined
        ? stateVars.GetStationInfo?.length > 0
          ? stateVars.GetStationInfo[0].stationName
          : null
        : this.state.GetStationInfo?.length > 0
        ? this.state.GetStationInfo[0].stationName
        : null
    );
    stateVars.GetProductDetail = result?.data.getProductDetail;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.SameProductCurrentCount = result?.data.sameProductCurrentCount;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_FormPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stdboxes_form_238713_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxIdentifier
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxIdentifier
        : null
    );

    stateVars.isComp238713Enabled =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].id
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stdboxes_form_118875_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetStationInfo !== undefined
        ? stateVars.GetStationInfo?.length > 0
          ? stateVars.GetStationInfo[0].stationName
          : null
        : this.state.GetStationInfo?.length > 0
        ? this.state.GetStationInfo[0].stationName
        : null
    );

    formVars.stdboxes_form_801715_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxCount
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxCount
        : null
    );

    formVars.stdboxes_form_880268_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].productId
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].productId
        : null
    );

    stateVars.dataSource_880268 =
      stateVars.SelectStdproductsForProductid ??
      this.state.SelectStdproductsForProductid;
    stateVars.dataSource_880268 =
      stateVars.SelectStdproductsForProductid ??
      this.state.SelectStdproductsForProductid;
    formVars.stdboxes_form_865868_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].customerProductCode
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].customerProductCode
        : null
    );

    formVars.stdboxes_form_804937_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].customerProductDesc
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].customerProductDesc
        : null
    );

    formVars.stdboxes_form_34223_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].boxType
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].boxType
        : null
    );

    formVars.stdboxes_form_994812_value = ReactSystemFunctions.value(
      this,
      stateVars.SelectSTDBoxes !== undefined
        ? stateVars.SelectSTDBoxes?.length > 0
          ? stateVars.SelectSTDBoxes[0].expectedQuantity
          : null
        : this.state.SelectSTDBoxes?.length > 0
        ? this.state.SelectSTDBoxes[0].expectedQuantity
        : null
    );

    stateVars.isComp448809Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxEdit
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxEdit
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp891256Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetUserWithGroupDetails !== undefined
            ? stateVars.GetUserWithGroupDetails?.length > 0
              ? stateVars.GetUserWithGroupDetails[0].boxDelete
              : null
            : this.state.GetUserWithGroupDetails?.length > 0
            ? this.state.GetUserWithGroupDetails[0].boxDelete
            : null
        ),
        true
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  STDBoxes_FormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_829751_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      companyName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].customerName
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].customerName
            : null
        ),
        "string"
      ),
      stdProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].stdProductCode
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].stdProductCode
            : null
        ),
        "string"
      ),
      stdProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].stdProductName
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].stdProductName
            : null
        ),
        "string"
      ),
      customerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].customerProductDesc
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].customerProductDesc
            : null
        ),
        "string"
      ),
      customerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].customerProductCode
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].customerProductCode
            : null
        ),
        "string"
      ),
      qrCodeUrl_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxCount
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxCount
            : null
        ),
        "string"
      ),
      kutuId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].expectedQuantity
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].expectedQuantity
            : null
        ),
        "string"
      ),
      barcodeValue_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      boxNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_829751_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_FormComponent_829751_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_829751_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp324177Visible",
          "string"
        )
      );
    stateVars.ToggleVisibilityOf =
      await ReactSystemFunctions.toggleVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp423219Visible",
          "string"
        )
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_FormComponent_829751_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_829751_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_829751_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };

  STDBoxes_FormComponent_382198_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.GetLabelWithBoxId !== undefined
          ? stateVars.GetLabelWithBoxId?.length > 0
            ? stateVars.GetLabelWithBoxId[0].fileData
            : null
          : this.state.GetLabelWithBoxId?.length > 0
          ? this.state.GetLabelWithBoxId[0].fileData
          : null
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.GetLabelWithBoxId !== undefined
          ? stateVars.GetLabelWithBoxId?.length > 0
            ? stateVars.GetLabelWithBoxId[0].fileName
            : null
          : this.state.GetLabelWithBoxId?.length > 0
          ? this.state.GetLabelWithBoxId[0].fileName
          : null
      )
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_880268_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StdProductCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_880268_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductDetail = result?.data.getProductDetail;
    stateVars.STDCustomerProductsWithProductCode =
      result?.data.stdCustomerProductsWithProductCode;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_FormComponent_880268_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_880268_onChange_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName("isComp804937Enabled", "string"),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );
    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName("isComp865868Enabled", "string"),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_880268_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.STDCustomerProductsWithProductCode !== undefined
            ? stateVars.STDCustomerProductsWithProductCode?.length > 0
              ? stateVars.STDCustomerProductsWithProductCode[0].id
              : null
            : this.state.STDCustomerProductsWithProductCode?.length > 0
            ? this.state.STDCustomerProductsWithProductCode[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDBoxes_FormComponent_880268_onChange_if1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StdProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDCustomerProductsWithProductCode =
      result?.data.stdCustomerProductsWithProductCode;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.STDBoxes_FormComponent_448809_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CustomerId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].customerId
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].customerId
            : null
        ),
        "Guid"
      ),
      ProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ProductName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      StdProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      UpdatedAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      UpdatedBy_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_if1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDCustomerProductsSave = result?.data.stdCustomerProductsSave;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      NewBoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxCount_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxType_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_4: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "string"
      ),
      kutuId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_if1f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSameProductCount = result?.data.getSameProductCount;
    stateVars.DeleteEtiketForAddedManuelBox =
      result?.data.deleteEtiketForAddedManuelBox;
    stateVars.UpdateBoxCount = result?.data.updateBoxCount;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1f1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1f1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "0eec0293_a3b9_1553_0315_a7d84664f6aa_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      BoxType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      kutuId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_5: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_if1f1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1f1e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1f1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "3bdeea19_aa64_fe29_76f3_36140f52589b_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "3215"
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "4315"
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1f1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1e11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1e1f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1e1f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "number"
      ),
      NewBoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "number"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "number"
      ),
      BoxId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "number"
      ),
      BoxType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_3: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "string"
      ),
      kutuId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_if1e1f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DeleteEtiketForAddedManuelBox =
      result?.data.deleteEtiketForAddedManuelBox;
    stateVars.UpdateBoxCount = result?.data.updateBoxCount;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1e1f1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1e1f1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "236fede5_d938_bace_4a25_4c8b81e0f787_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1e1f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      BoxType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      kutuId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_5: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_if1e1f1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1e1f1e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1e1f1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "dda11477_ffe1_e55a_ab08_f63f2dd2ade1_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1e1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "3215"
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "4315"
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1e1f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1e1f1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1e1e11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1e1e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      NewBoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxCount_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxType_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_4: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "string"
      ),
      kutuId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_if1e1e1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSameProductCount = result?.data.getSameProductCount;
    stateVars.DeleteEtiketForAddedManuelBox =
      result?.data.deleteEtiketForAddedManuelBox;
    stateVars.UpdateBoxCount = result?.data.updateBoxCount;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1e1e1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1e1e1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "624e99fc_01ce_c2a6_d7e7_0579c9e67ff2_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1e1e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      BoxType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      kutuId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_5: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_if1e1e1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_if1e1e1e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_if1e1e1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "a6e4309a_f36a_d8e6_3844_f34a02ec879b_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1e1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "3215"
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "4315"
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1e1e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1e1e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].productId
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].productId
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_if11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_if1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      NewBoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxCount_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxType_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_4: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "string"
      ),
      kutuId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_else1f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSameProductCount = result?.data.getSameProductCount;
    stateVars.DeleteEtiketForAddedManuelBox =
      result?.data.deleteEtiketForAddedManuelBox;
    stateVars.UpdateBoxCount = result?.data.updateBoxCount;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1f1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1f1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "7747a746_9a3f_5ff0_e3ee_ad34b246a40f_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      BoxType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      kutuId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_5: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_else1f1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1f1e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1f1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "420153e9_6be7_d401_b97d_248f5d642cd9_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "3215"
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "4315"
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1f1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1e11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1e1f11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1e1f1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "number"
      ),
      NewBoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "number"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "number"
      ),
      BoxId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "number"
      ),
      BoxType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_3: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SameProductCurrentCount !== undefined
            ? stateVars.SameProductCurrentCount?.length > 0
              ? stateVars.SameProductCurrentCount[0].count
              : null
            : this.state.SameProductCurrentCount?.length > 0
            ? this.state.SameProductCurrentCount[0].count
            : null
        ),
        "string"
      ),
      kutuId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_else1e1f1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DeleteEtiketForAddedManuelBox =
      result?.data.deleteEtiketForAddedManuelBox;
    stateVars.UpdateBoxCount = result?.data.updateBoxCount;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1e1f1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1e1f1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "340cb9a9_cf1c_9fcf_25c3_682267787a54_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1e1f1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      BoxType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      kutuId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_5: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_else1e1f1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1e1f1e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1e1f1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "101b916d_745e_2661_60c0_e029119bc88b_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1e1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "3215"
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "4315"
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1e1f1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1e1f1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1e1e11_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1e1e1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      NewBoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxId_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxCount_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "number"
      ),
      BoxType_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_4: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSameProductCount !== undefined
            ? stateVars.GetSameProductCount?.length > 0
              ? stateVars.GetSameProductCount[0].count
              : null
            : this.state.GetSameProductCount?.length > 0
            ? this.state.GetSameProductCount[0].count
            : null
        ),
        "string"
      ),
      kutuId_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_7: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_7: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_7: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_8: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_else1e1e1f1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetSameProductCount = result?.data.getSameProductCount;
    stateVars.DeleteEtiketForAddedManuelBox =
      result?.data.deleteEtiketForAddedManuelBox;
    stateVars.UpdateBoxCount = result?.data.updateBoxCount;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1e1e1f11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1e1e1f11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "2736c9b4_15d6_935b_fac9_71076d0fc70b_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1e1e1e1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_865868_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_865868_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stdboxes_form_804937_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required",
      formName: "stdboxes_form_804937_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxCount_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      BoxType_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      CreatedAt_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].createdAt
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].createdAt
            : null
        ),
        "Date"
      ),
      CustomerProductCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      CustomerProductDesc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      ExpectedQuantity_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      ProductId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      StationId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      UpdateAt_0: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      BoxId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      companyName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      stdProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productCode"
          )
        ),
        "string"
      ),
      stdProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "productName"
          )
        ),
        "string"
      ),
      customerProductDesc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_804937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      customerProductCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      qrCodeUrl_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      stationName_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      BoxCount_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("1", "string"),
        "string"
      ),
      kutuId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      istasyonAdi_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].stationName
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].stationName
            : null
        ),
        "string"
      ),
      quantity_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_994812_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      barcodeValue_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_865868_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      boxNumber_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "string"
      ),
      labelType_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetStationInfo !== undefined
            ? stateVars.GetStationInfo?.length > 0
              ? stateVars.GetStationInfo[0].name
              : null
            : this.state.GetStationInfo?.length > 0
            ? this.state.GetStationInfo[0].name
            : null
        ),
        "string"
      ),
      parameter1_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].boxIdentifier
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].boxIdentifier
            : null
        ),
        "string"
      ),
      BoxId_5: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      fileData_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.GenerateExactLabel),
        "string"
      ),
      fileName_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.StringForLabelName),
        "string"
      ),
      Id_5: ReactSystemFunctions.convertToTypeByName(
        Guid.create().toString(),
        "Guid"
      ),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_448809_onClick_else1e1e1e1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDBoxesSave = result?.data.stdBoxesSave;
    stateVars.STDEtiketDeleteByBoxId = result?.data.stdEtiketDeleteByBoxId;
    stateVars.GetNewBoxIdent = result?.data.getNewBoxIdent;
    stateVars.GenerateExactLabel = result?.data.generateExactLabel;
    stateVars.StringForLabelName = result?.data.stringForLabelName;
    stateVars.STDEtiketSave = result?.data.stdEtiketSave;
    stateVars.GetLabelWithBoxId = result?.data.getLabelWithBoxId;
    stateVars.isComp324177Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp423219Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetLabelWithBoxId !== undefined
            ? stateVars.GetLabelWithBoxId?.length > 0
              ? stateVars.GetLabelWithBoxId[0].id
              : null
            : this.state.GetLabelWithBoxId?.length > 0
            ? this.state.GetLabelWithBoxId[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_448809_onClick_else1e1e1e11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_448809_onClick_else1e1e1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "41d8f2a9_43b1_03d8_601e_ab144ebd2f83_notify",
        this.defaultML,
        "Kutu bilgileri güncellendi!"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      4,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1e1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "3215"
      ) ||
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_34223_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "4315"
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1e1e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1e1e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else1e11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        ReactSystemFunctions.value(
          this,
          stateVars.SelectSTDBoxes !== undefined
            ? stateVars.SelectSTDBoxes?.length > 0
              ? stateVars.SelectSTDBoxes[0].productId
              : null
            : this.state.SelectSTDBoxes?.length > 0
            ? this.state.SelectSTDBoxes[0].productId
            : null
        )
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1e1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1e1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        true
      )
    ) {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1f1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1e1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_448809_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.STDCustomerProductsWithProductCode !== undefined
            ? stateVars.STDCustomerProductsWithProductCode?.length > 0
              ? stateVars.STDCustomerProductsWithProductCode[0].id
              : null
            : this.state.STDCustomerProductsWithProductCode?.length > 0
            ? this.state.STDCustomerProductsWithProductCode[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.STDBoxes_FormComponent_448809_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred =
        await this.STDBoxes_FormComponent_448809_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_891256_onClick_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Subtract = await ReactSystemFunctions.subtract(
      ReactSystemFunctions.value(
        this,
        stateVars.SelectSTDBoxes !== undefined
          ? stateVars.SelectSTDBoxes?.length > 0
            ? stateVars.SelectSTDBoxes[0].boxCount
            : null
          : this.state.SelectSTDBoxes?.length > 0
          ? this.state.SelectSTDBoxes[0].boxCount
          : null
      ),
      1
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_891256_onClick_if01_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  STDBoxes_FormComponent_891256_onClick_if01_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BoxId_0: ReactSystemFunctions.convertToTypeByName(null, "Guid"),
      KutuId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      StationId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.Subtract),
        "number"
      ),
      NewBoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.Subtract),
        "number"
      ),
      StationId_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.stationId ?? this.props.screenInputs.stationid,
        "Guid"
      ),
      ProductId_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stdboxes_form_880268_value",
            "value",
            "SelectStdproductsForProductid",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      BoxCount_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.Subtract),
        "number"
      ),
      Id_3: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "STDBoxes_Form/STDBoxes_FormComponent_891256_onClick_if01_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.STDOrdersUpdateDeletingBox =
      result?.data.stdOrdersUpdateDeletingBox;
    stateVars.DeleteEtiketForDeletingBox =
      result?.data.deleteEtiketForDeletingBox;
    stateVars.UpdateBoxCountAfterDeleteBox =
      result?.data.updateBoxCountAfterDeleteBox;
    stateVars.STDBoxesDeleteById = result?.data.stdBoxesDeleteById;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_891256_onClick_if02_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  STDBoxes_FormComponent_891256_onClick_if02_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  STDBoxes_FormComponent_891256_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "7ce5b4f3_57b0_deb5_cc6a_770f4e5aa95f_confirmation",
        this.defaultML,
        "KLT Kutusunu silmek istiyor musunuz?"
      ),
      "poppins",
      "",
      "",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (ReactSystemFunctions.isEqualTo(true, true)) {
        isErrorOccurred =
          await this.STDBoxes_FormComponent_891256_onClick_if0();
        if (isErrorOccurred) return true;
      } else {
      }
      KuikaAppManager.showSpinner(this);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (
      isFromMaster ||
      ((window.kuika?.disableSmartExecutePageInit?.["STDBoxes_Form"] ??
        false) &&
        pageInitCallerNavDiIDs.indexOf(diId) > -1)
    ) {
      await this.STDBoxes_FormPageInit();
    } else if (
      window.kuika?.serverRequestCount > 0 &&
      pageInitCallerNavDiIDs.indexOf(diId) > -1
    ) {
      await this.STDBoxes_FormPageInit();
    }
  }
}
